import { Record } from "immutable";
import { v4 as uuid } from "uuid";

export const feneTechManufacturerFromJSON = (json: Partial<IFeneTechManufacturerData>): FeneTechManufacturerRecord => {
  const record: IFeneTechManufacturerRecord = { ...(json as any) };

  if (!record.id) {
    record.id = uuid();
  }

  return new FeneTechManufacturerRecord(record);
};

export interface IFeneTechManufacturerData {
  id: string;
  url: string;
  name: string;
  image: string;
}

export interface IFeneTechManufacturerRecord {
  id: string;
  url: string;
  name: string;
  image: string;
}

const defaultManufacturerProps: IFeneTechManufacturerRecord = {
  id: "",
  url: "",
  name: "",
  image: "",
};

export class FeneTechManufacturerRecord
  extends Record(defaultManufacturerProps)
  implements IFeneTechManufacturerRecord {}
